import View from '../view';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './index_mWeb.css';
import { redirectHyperLinks } from '../../utilities/helper';
import Constants from '../../constants';
import Text from '../text';

const FooterMWeb = ({ footerBackground }: any) => {
  const footerHeaderSx = {
    color: 'white',
    fontSize: '1.2rem',
    fontWeight: 600,
    fontFamily: 'Poppins'
  };
  const footerItemSx = {
    color: '#b2b7bc',
    fontSize: '1.1rem',
    fontWeight: 500,
    fontFamily: 'Poppins',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center'
  };
  const accordionSx = { backgroundColor: '#0c1014', marginBottom: '15px', borderRadius: '5px' };
  return (
    <View className="footer__wrapper__mWeb" style={footerBackground}>
      <Accordion sx={accordionSx}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="large" style={{ color: 'white' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <Typography sx={footerHeaderSx}>Applications</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={footerItemSx}
            onClick={() => redirectHyperLinks('whitelabelpokersoftware')}>
            White Label Poker Software
          </Typography>
          <Typography
            style={footerItemSx}
            onClick={() => redirectHyperLinks('fantasysportspublisherintegration')}>
            Fantasy Sports Publisher Integration
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('gamionetwork')}>
            The Gamio Network
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('gamiodevelopment')}>
            Game Development
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={accordionSx}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="large" style={{ color: 'white' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <Typography sx={footerHeaderSx}>iGamio</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('aboutus')}>
            About Us
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('contactus')}>
            Contact us
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('careers')}>
            Careers
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('pokerarticles')}>
            Poker Articles
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('fantasyarticles')}>
            Fantasy Articles
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={accordionSx}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="large" style={{ color: 'white' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <Typography sx={footerHeaderSx}>Contact us</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={footerItemSx}>
            <Constants.Svgs.Phone className="footer_contactUs__icons" />
            +91 9311779940
          </Typography>
          <Typography style={footerItemSx}>
            <Constants.Svgs.Email className="footer_contactUs__icons" />
            sales@gamiotech.com
          </Typography>
          <Typography style={footerItemSx} onClick={() => redirectHyperLinks('igamio')}>
            <Constants.Svgs.Website className="footer_contactUs__icons" /> www.gamiotech.com
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={accordionSx}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="large" style={{ color: 'white' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <Typography sx={footerHeaderSx}>Follow us</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <img
            src={Constants.Images.instagram}
            className="footer__socialMedia__links__img__mWeb"
            onClick={() => redirectHyperLinks('instagram')}
          />
          <img
            className="footer__socialMedia__links__img__mWeb"
            src={Constants.Images.twitter}
            onClick={() => redirectHyperLinks('twitter')}
          />
          <img
            className="footer__socialMedia__links__img__mWeb"
            src={Constants.Images.youtube}
            onClick={() => redirectHyperLinks('youtube')}
          />
          <img
            className="footer__socialMedia__links__img__mWeb"
            src={Constants.Images.facebook}
            onClick={() => redirectHyperLinks('facebook')}
          />
          <img
            className="footer__socialMedia__links__img__mWeb"
            src={Constants.Images.linkedin}
            onClick={() => redirectHyperLinks('linkedin')}
          />
        </AccordionDetails>
      </Accordion>
      <View className="footer__copyRights__txt">
        <Text> {'Copyright (c) 2022. iGamio Pvt Ltd.'}</Text>
        <Text>{'All rights reserved.'}</Text>
      </View>
    </View>
  );
};

export default FooterMWeb;
